import React from 'react';
import { FilterState } from '../types/api';

export interface AvatarData {
  id: number;
  image: string;
  prompt: string;
  filters: Partial<FilterState>;
}

interface InteractiveSliderCardProps {
  id: number;
  isSelected: boolean;
  onSelect: (id: number) => void;
  onCopyPrompt: (prompt: string) => void;
  isHovered?: boolean;
  onHover?: (id: number | null) => void;
}

const avatarData: AvatarData[] = [
  {
    id: 0,
    image: "https://assets.bigvu.tv/AssetFileType.AI_AVATAR/68bec49ad9d21c37924db826/3efcac28-ac4a-4813-b6b3-1d58b6948559-video_thumb_1080.0000001.jpeg",
    prompt: "Professional male avatar named Elliot, confident and approachable expression, modern business setting, clean professional appearance suitable for corporate presentations and business communications.",
    filters: {
      gender: 'male',
      age: '30s',
      hair: ['black'],
      background: 'Home Office',
      style: {
        type: 'cartoon',
        ratio: 'vertical',
        scene: 'full-body'
      }
    }
  },
  {
    id: 1,
    image: "https://assets.bigvu.tv/AssetFileType.AI_AVATAR/68bec476170cab569b2f5193/932e6002-029d-4f73-8f81-7829498b7d5e-video_thumb_1080.0000001.jpeg",
    prompt: "Professional female avatar named Lidia, warm and engaging presence, modern professional setting, trustworthy appearance ideal for customer service and educational content.",
    filters: {
      gender: 'female',
      age: '40s',
      hair: ['curly'],
      background: 'Home Office',
      style: {
        type: 'cartoon',
        ratio: 'vertical',
        scene: 'full-body'
      }
    }
  },
  {
    id: 2,
    image: "https://assets.bigvu.tv/AssetFileType.AI_AVATAR/68b0535392c2257b949219da/7db434cd-bbc3-449d-85d1-86c715936cac-video_thumb_1080.0000001.jpeg",
    prompt: "Energetic female avatar named Harper, bright and confident personality, uplifting energy perfect for inspiring content, marketing presentations, and motivational videos.",
    filters: {
      gender: 'female',
      age: '30s',
      hair: ['black'],
      background: 'Green Screen',
      style: {
        type: 'photorealistic',
        ratio: 'vertical',
        scene: 'mid-closeup'
      }
    }
  },
  {
    id: 3,
    image: "https://assets.bigvu.tv/AssetFileType.AI_AVATAR/68b0532053b98814caf90c7f/83403ecb-b325-4e7d-b2c3-530c290947ee-video_thumb_1080.0000001.jpeg",
    prompt: "Stylish female avatar named Luna, confident and elegant presence, modern energy ideal for fashion content, lifestyle videos, and contemporary brand presentations.",
    filters: {
      gender: 'female',
      age: '30s',
      hair: ['black'],
      background: 'Green Screen',
      style: {
        type: 'photorealistic',
        ratio: 'vertical',
        scene: 'mid-closeup'
      }
    }
  },
  {
    id: 4,
    image: "https://assets.bigvu.tv/AssetFileType.AI_AVATAR/68b06660d5f05e4779609b2d/beb39eef-eea7-4567-9653-506579c78d1a-video_thumb_1080.0000001.jpeg",
    prompt: "Professional female avatar named Ankita, composed and sincere presence, trustworthy appearance perfect for professional training, corporate communications, and educational content.",
    filters: {
      gender: 'female',
      age: '20s',
      hair: ['black'],
      background: 'Green Screen',
      style: {
        type: 'photorealistic',
        ratio: 'vertical',
        scene: 'mid-closeup'
      }
    }
  },
  {
    id: 5,
    image: "https://assets.bigvu.tv/AssetFileType.AI_AVATAR/68b0669b53b98814cafa4edf/77c0472d-05c4-4ec1-b2c1-5231e7aaadf6-video_thumb_1080.0000001.jpeg",
    prompt: "Creative male avatar named Hilario, thoughtful and enthusiastic presence, approachable style ideal for creative content, artistic presentations, and innovative brand messaging.",
    filters: {
      gender: 'male',
      age: '30s',
      hair: ['black'],
      background: 'green screen',
      style: {
        type: 'photorealistic',
        ratio: 'vertical',
        scene: 'mid-closeup'
      }
    }
  },
  {
    id: 6,
    image: "https://assets.bigvu.tv/AssetFileType.AI_AVATAR/68b066b792c2257b94935a55/0a3549bf-e053-4332-8af8-cdf31ec231d8-video_thumb_1080.0000001.jpeg",
    prompt: "Bold female avatar named Treva, energetic and creative personality, lively presence perfect for dynamic content, entertainment videos, and attention-grabbing presentations.",
    filters: {
      gender: 'female',
      age: '20s',
      hair: ['black'],
      background: 'Green Screen',
      style: {
        type: 'photorealistic',
        ratio: 'vertical',
        scene: 'mid-closeup'
      }
    }
  },
  {
    id: 7,
    image: "https://assets.bigvu.tv/AssetFileType.AI_AVATAR/68b06681d5f05e4779609d70/8db0f930-15c9-4195-8247-c61809d63773-video_thumb_360.0000001.jpeg",
    prompt: "Friendly female avatar named Jacqueline, approachable and warm presence, natural energy ideal for customer service, community content, and relatable brand communications.",
    filters: {
      gender: 'female',
      age: '30s',
      hair: ['brunette'],
      background: 'Green Screen',
      style: {
        type: 'photorealistic',
        ratio: 'vertical',
        scene: 'mid-closeup'
      }
    }
  },
  {
    id: 8,
    image: "https://assets.bigvu.tv/AssetFileType.AI_AVATAR/68b066d153b98814cafa5297/0fcece59-4c21-4687-a370-b900eb9cbf33-video_thumb_1080.0000001.jpeg",
    prompt: "Professional female avatar named Joclyne, confident and composed presence, direct delivery style perfect for business presentations, professional training, and authoritative content.",
    filters: {
      gender: 'female',
      age: '40s',
      hair: ['curly'],
      background: 'Green Screen',
      style: {
        type: 'photorealistic',
        ratio: 'vertical',
        scene: 'mid-closeup'
      }
    }
  },
  {
    id: 9,
    image: "https://assets.bigvu.tv/AssetFileType.AI_AVATAR/68b5ab4c338d1ff2eedd4bca/e0b2b2f1-4408-4fca-80cc-2e607ae14ee0-video_thumb_1080.0000001.jpeg",
    prompt: "Dynamic male avatar named Brad, charismatic and passionate presence, positive energy ideal for motivational content, sales presentations, and engaging brand communications.",
    filters: {
      gender: 'male',
      age: '30s',
      hair: ['brunette'],
      background: 'Green Screen',
      style: {
        type: 'photorealistic',
        ratio: 'vertical',
        scene: 'mid-closeup'
      }
    }
  },
  {
    id: 10,
    image: "https://assets.bigvu.tv/AssetFileType.AI_AVATAR/68b065ca53b98814cafa413b/023c7a49-1a7d-4841-b67e-0d6d2b4f762a-video_thumb_1080.0000001.jpeg",
    prompt: "Ambitious female avatar named Lori, bright and confident presence, poised delivery perfect for leadership content, career development, and inspiring presentations.",
    filters: {
      gender: 'female',
      age: '20s',
      hair: ['brunette'],
      background: 'any',
      style: {
        type: 'photorealistic',
        ratio: 'vertical',
        scene: 'full-body'
      }
    }
  },
  {
    id: 11,
    image: "https://assets.bigvu.tv/AssetFileType.AI_AVATAR/68b0660553b98814cafa4529/1a091b25-b184-477a-b796-25ae9b9d030f-video_thumb_1080.0000001.jpeg",
    prompt: "Analytical male avatar named Dave, focused and precise presence, tech-savvy appearance ideal for data presentations, technical content, and professional analysis videos.",
    filters: {
      gender: 'male',
      age: '20s',
      hair: ['black'],
      background: 'Home Office',
      style: {
        type: 'photorealistic',
        ratio: 'vertical',
        scene: 'full-body'
      }
    }
  },
  {
    id: 12,
    image: "https://assets.bigvu.tv/AssetFileType.AI_AVATAR/68b0662592c2257b949350d0/737806e3-bb38-4a32-9f14-1ad42db8a332-video_thumb_1080.0000001.jpeg",
    prompt: "Experienced male avatar named Alfred, reliable and grounded presence, approachable style perfect for educational content, mentorship videos, and trustworthy communications.",
    filters: {
      gender: 'male',
      age: '50s',
      hair: ['grey'],
      background: 'any',
      style: {
        type: 'photorealistic',
        ratio: 'vertical',
        scene: 'full-body'
      }
    }
  },
  {
    id: 13,
    image: "https://assets.bigvu.tv/AssetFileType.AI_AVATAR/68b0655692c2257b949342c5/8a0dcaa7-88d7-4e88-beb6-4aa7858cb0ea-video_thumb_1080.0000001.jpeg",
    prompt: "Strong female avatar named Rita, brave and determined presence, powerful delivery ideal for leadership content, motivational speeches, and confidence-building presentations.",
    filters: {
      gender: 'female',
      age: '40s',
      hair: ['brunette'],
      background: 'any',
      style: {
        type: 'photorealistic',
        ratio: 'vertical',
        scene: 'full-body'
      }
    }
  },
  {
    id: 14,
    image: "https://assets.bigvu.tv/AssetFileType.AI_AVATAR/68b1ce0192c2257b94a57c95/d68bf512-6beb-49e7-ae8e-ff136d397030-video_thumb_1080.0000001.jpeg",
    prompt: "Creative male avatar named Tony, focused and passionate presence, modern style perfect for creative content, artistic presentations, and innovative brand messaging.",
    filters: {
      gender: 'male',
      age: '20s',
      hair: ['brunette'],
      background: 'Home Office',
      style: {
        type: 'photorealistic',
        ratio: 'vertical',
        scene: 'full-body'
      }
    }
  },
  {
    id: 15,
    image: "https://assets.bigvu.tv/AssetFileType.AI_AVATAR/68b1ce1fd5f05e477972c655/f58b3489-547c-4b50-b71c-ee3c31c0ebc8-video_thumb_1080.0000001.jpeg",
    prompt: "Futuristic male avatar named Viktor, dynamic and intense presence, commanding delivery ideal for tech content, innovative presentations, and cutting-edge brand communications.",
    filters: {
      gender: 'male',
      age: '20s',
      hair: ['black'],
      background: 'any',
      style: {
        type: 'photorealistic',
        ratio: 'vertical',
        scene: 'full-body'
      }
    }
  },
  {
    id: 16,
    image: "https://assets.bigvu.tv/AssetFileType.AI_AVATAR/68b550be352d725fe4ae4f14/165ab3f5-b44f-4085-bc81-e3339899a4fe-video_thumb_1080.0000001.jpeg",
    prompt: "Articulate male avatar named Alan, confident and authoritative presence, professional style perfect for educational content, news presentations, and informative communications.",
    filters: {
      gender: 'male',
      age: '50s',
      hair: ['brunette'],
      background: 'Interview setup with mic',
      style: {
        type: 'photorealistic',
        ratio: 'vertical',
        scene: 'full-body'
      }
    }
  },
  {
    id: 17,
    image: "https://assets.bigvu.tv/AssetFileType.AI_AVATAR/68b065a892c2257b94934888/78782dc3-2436-4784-8e70-8d5a567d5147-video_thumb_1080.0000001.jpeg",
    prompt: "Disciplined female avatar named Michaels, composed and strong presence, professional style ideal for corporate training, leadership content, and authoritative presentations.",
    filters: {
      gender: 'female',
      age: '30s',
      hair: ['brunette'],
      background: 'any',
      style: {
        type: 'photorealistic',
        ratio: 'vertical',
        scene: 'full-body'
      }
    }
  },
  {
    id: 18,
    image: "https://assets.bigvu.tv/AssetFileType.AI_AVATAR/68b85c28338d1ff2ee00d3eb/6ef674f6-2f0e-46b8-9ddf-b3d7a048a695-video_thumb_1080.0000001.jpeg",
    prompt: "Energetic female avatar named Melly, positive and enthusiastic presence, sporty vibe perfect for fitness content, lifestyle videos, and dynamic brand communications.",
    filters: {
      gender: 'female',
      age: '30s',
      hair: ['blonde'],
      background: 'any',
      style: {
        type: 'cartoon',
        ratio: 'vertical',
        scene: 'full-body'
      }
    }
  },
  {
    id: 19,
    image: "https://assets.bigvu.tv/AssetFileType.AI_AVATAR/68b85afc827ed616e68fd524/db589fbb-74c8-4f24-9978-e3e4a6867ac7-video_thumb_1080.0000001.jpeg",
    prompt: "Fun male avatar named Luice, approachable and confident presence, casual style ideal for entertainment content, social media videos, and relatable brand messaging.",
    filters: {
      gender: 'male',
      age: '50s',
      hair: ['brunette'],
      background: 'any',
      style: {
        type: 'cartoon',
        ratio: 'vertical',
        scene: 'full-body'
      }
    }
  }
];

export default function InteractiveSliderCard({ id, isSelected, onSelect, onCopyPrompt, isHovered = false, onHover }: InteractiveSliderCardProps) {
  const avatar = avatarData[id];
  
  const handleClick = () => {
    onSelect(id);
    // Set prompt directly to prompt field when clicking on card (no clipboard copy)
    // onCopyPrompt is used here but the parent will handle it as prompt field update
    onCopyPrompt(avatar.prompt);
  };

  const handleMouseEnter = () => {
    onHover?.(id);
  };

  const handleMouseLeave = () => {
    onHover?.(null);
  };

  return (
    <div 
      className={`relative w-[177px] h-[315px] cursor-pointer transition-all duration-300 ${
        isHovered === true ? 'scale-105' : 
        // isHovered === false ? 'opacity-60' : 
        'over:scale-100'
      }`}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div 
        className="bg-center bg-cover bg-no-repeat rounded-[10px] w-full h-full"
        style={{ backgroundImage: `url('${avatar.image}')` }}
      />
      
      {/* Prompt overlay - show on hover */}
      {(isHovered || (isHovered === undefined && isSelected)) && (
        <div className="absolute bottom-0 left-0 right-0 bg-white rounded-b-[10px] p-2 shadow-lg">
          <p className="text-[10px] text-blue-black-90 leading-[1.3]">
            {avatar.prompt}
          </p>
        </div>
      )}
    </div>
  );
}

export { avatarData };
